module.exports = __webpack_public_path__ + "img/scheuersaugmaschinen.b481b17.png";